import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { BaseService } from '../../../shared/services/base.service';
import { SubmitContact, SubmitContactAssistance } from '../models/contact-data';
import { SubmitFormHowItWorks } from '../models/how-it-works-data';

@Injectable()
export class FormsService extends BaseService {
	constructor(private readonly http: HttpClient) {
		super();
	}

	submitContact(body: SubmitContact) {
		return this.http.post<any>(`${environment.apiUrl}user-prospects/contact-us`, body).pipe(take(1));
	}

	submitContactAssistance(body: SubmitContactAssistance) {
		return this.http.post<any>(`${environment.apiUrl}user-prospects/request-assistance`, body);
	}

	submitUserProspect(body: SubmitFormHowItWorks) {
		return this.http.post<any>(`${environment.apiUrl}user-prospects`, body);
	}
}
